import { render } from "./LoadingSpinner.vue?vue&type=template&id=8be703ee&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=8be703ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8be703ee"

export default script